// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/7113b73b/" + chunkId + "." + __webpack_require__.h() + ".v7113b73b.js";
};